import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import Header from '../components/Header';
import { APP_INFO } from '../data/defaultData';
import { Sun, Flame, Sparkles, Lamp, Music, ChevronRight, BookOpen } from 'lucide-react';

const ICONS = { Sun, Flame, Sparkles, Lamp, Music, BookOpen };

export default function Home() {
  const navigate = useNavigate();
  const { topics } = useApp();

  return (
    <div className="min-h-screen">
      <Header title={APP_INFO.name} subtitle={APP_INFO.tagline} />

      <div className="max-w-5xl mx-auto px-4 py-6">
        <div className="saffron-soft rounded-2xl p-5 mb-6 om-bg border border-orange-200">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl bg-orange-500 text-white flex items-center justify-center text-2xl devanagari font-bold">ॐ</div>
            <div>
              <h2 className="text-xl font-bold text-orange-900 devanagari-ui">स्वागतम्</h2>
              <p className="text-sm text-orange-800/80">वैदिक मन्त्र, संस्कार एवं यज्ञ प्रक्रिया</p>
            </div>
          </div>
        </div>

        <h3 className="text-sm font-semibold text-orange-900/70 uppercase tracking-wide mb-3 px-1">विषय सूची</h3>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {topics.map((topic) => {
            const Icon = ICONS[topic.icon] || BookOpen;
            return (
              <button
                key={topic.id}
                onClick={() => navigate(`/topic/${topic.id}`)}
                className="card-hover group bg-white rounded-2xl p-4 border border-orange-100 shadow-sm text-left flex items-center gap-4"
              >
                <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${topic.color} flex items-center justify-center text-white shadow-md shrink-0`}>
                  <Icon className="w-7 h-7" />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="font-bold text-orange-950 devanagari-ui truncate">{topic.title}</h4>
                  <p className="text-xs text-stone-500 truncate">{topic.subtitle} · {topic.mantras.length} मन्त्र</p>
                </div>
                <ChevronRight className="w-5 h-5 text-orange-400 group-hover:translate-x-1 transition-transform" />
              </button>
            );
          })}
        </div>

        <div className="mt-8 text-center text-xs text-stone-500">
          <p>ॐ शान्तिः शान्तिः शान्तिः</p>
        </div>
      </div>
    </div>
  );
}
